import { PrismicRichText } from '@prismicio/react';
import { RichText } from 'prismic-reactjs';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { OverviewTitleComponent } from '@/src/components/OverviewSection';
import { PricingOverviewSection as PricingOverviewSectionRefreshed } from '@/src/components/PricingTable/PricingOverviewRefreshed';
import { PricingOverviewSection } from '@/src/components/PricingTable/PricingOverviewVol3';
import { ContactUsFormButton } from '@/src/domains/shared/forms/ContactUsForm';

const PricingSectionWrapper = styled.section`
  color: var(--colors-bayoux);
  background-image: var(--colors-zircon);
`;

const PricingSectionHeader = styled.header`
  text-align: center;
  ${fluidProp(['padding-top'], '100px', '140px')}
  ${fluidProp(['padding-bottom'], '100px', '180px')}
`;

const Label = styled.div`
  margin: 0 auto 18px auto;
  text-align: center;

  & > small {
    ${({ theme }) => theme.typography.subHead}
    text-transform: uppercase;
    color: var(--colors-irisBlue);
  }
`;

export const PricingSection = ({ label, title, pricingOverview, hubspotFormDefinition }) => (
  <PricingSectionWrapper>
    <PricingSectionHeader>
      <ContentContainer>
        <Label>
          <small>{label}</small>
        </Label>
        <OverviewTitleComponent>{RichText.render(title)}</OverviewTitleComponent>
      </ContentContainer>
    </PricingSectionHeader>

    <PricingOverviewSection
      hubspotFormDefinition={hubspotFormDefinition}
      pricingOverview={pricingOverview}
      CustomCTAButton={ContactUsFormButton}
    />
  </PricingSectionWrapper>
);

export const PricingSectionRefreshed = ({
  label,
  title,
  pricingOverview,
  hubspotFormDefinition,
}) => (
  <PricingSectionWrapper>
    <PricingSectionHeader>
      <ContentContainer>
        <Label>
          <small>{label}</small>
        </Label>
        <OverviewTitleComponent>{RichText.render(title)}</OverviewTitleComponent>
      </ContentContainer>
    </PricingSectionHeader>

    <PricingOverviewSectionRefreshed
      hubspotFormDefinition={hubspotFormDefinition}
      pricingOverview={pricingOverview}
      CustomCTAButton={ContactUsFormButton}
    />
  </PricingSectionWrapper>
);

const SectionWrapper = styled(PricingSectionWrapper)`
  color: var(--colors-bayoux);
  background-color: #ebf2ff;
  background-image: none;

  ${PricingSectionHeader} {
    ${fluidProp('padding-bottom', '50px', '70px')};
  }

  ${Label} , ${OverviewTitleComponent} {
    font-family: var(--typography-fontBossa);
  }

  ${OverviewTitleComponent} {
    max-width: 90%;

    > * {
      font-family: inherit;
    }
  }
`;

export const NewPricingSection = ({
  label,
  title,
  pricingOverview,
  hubspotFormDefinition,
  learnMoreLabel,
  frenchLocale,
}) => (
  <SectionWrapper>
    <PricingSectionHeader>
      <ContentContainer>
        {fieldHasContent(label) && <Label>{label}</Label>}
        {fieldHasContent(title) && (
          <OverviewTitleComponent>
            <PrismicRichText field={title} />
          </OverviewTitleComponent>
        )}
      </ContentContainer>
    </PricingSectionHeader>

    <PricingOverviewSectionRefreshed
      hubspotFormDefinition={hubspotFormDefinition}
      pricingOverview={pricingOverview}
      CustomCTAButton={ContactUsFormButton}
      frenchLocale={frenchLocale}
      learnMoreLabel={learnMoreLabel}
    />
  </SectionWrapper>
);
